import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider as ThemeProviderOriginal } from "styled-components";
import { useTheme, createGlobalStyle } from "styled-components";
export const ThemeProvider = ({ children, theme, }) => _jsx(ThemeProviderOriginal, { theme: theme, children: children });
export { useTheme, createGlobalStyle };
